var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"15px"}},[_c('canvas',{ref:"canvas"}),_vm._v(" "),_c('span',{staticClass:"pacing-legend",domProps:{"innerHTML":_vm._s(_vm.legend)}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c20f5ab","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/dashboard/charts/DailyClientMetricsLineChart.vue
// module id = Szi0
// module chunks = 0